<template>
<section id="company-select">
    <NavbarDefault selection route="/" />
    <el-progress :stroke-width="2" :color="getPrimaryColorHex.four" :show-text="false" :percentage="100" v-if="$route.path.includes('signup')"/>
    <div class="container">
        <div class="row d-flex flex-column justify-content-center align-items-center new-company">
            <h2 :class="`text-center c-${getPrimaryColor}four`">Falta pouco, {{ userName | formatName }}!</h2>
            <p class="text-center">
                Agora, é só informar o CNPJ da empresa em que trabalha.
            </p>
            <div class="col-4 mt-5">
                <el-form @change="validateForm" :model="company" ref="company" :rules="rules" @keyup.native="validateForm" @submit.native.prevent>
                    <div class="mb-5">
                        <el-form-item prop="cnpj" :class="!cnpjOk ? 'is-error' : ''">
                            <!-- <InputText  v-model="company.cnpj" label="CNPJ" placeholder="CNPJ da empresa" v-mask="'##.###.###/####-##'"/> -->
                            <label>CNPJ</label>
                            <el-input :class="getPrimaryColor" v-model="company.cnpj" placeholder="CNPJ da empresa" v-mask="'##.###.###/####-##'" />
                        </el-form-item>
                    </div>
                    <div class="feedback my-4" v-if="formValid && $store.state.user.loading == false">
                        <CnpjNameCard v-if="cnpjOk" :name="company.name"></CnpjNameCard>
                        <AlreadyRegisteredCnpjCard v-if="!cnpjOk"></AlreadyRegisteredCnpjCard>
                    </div>
                    <!-- <div class="d-flex align-items-start">
                            <Exclamation class="mr-2 pb-1"/>
                        <div>
                            <h6 class="c-ndarkfour regular text-justify">
                                Sua empresa pretende antecipar recebíveis ou utilizar outras linhas de
                                crédito disponíveis na plataforma?
                            </h6>
                            <el-form-item prop="intentUseCredit">
                                <el-radio :class="getPrimaryColor" v-model="company.intentUseCredit" :label="true">Sim</el-radio>
                                <el-radio :class="getPrimaryColor" v-model="company.intentUseCredit" :label="false">Não</el-radio>
                            </el-form-item>
                        </div>
                    </div> -->
                    <Button size="large" :disabled="!formValid || !cnpjOk" @click="nextStep" :color="getPrimaryColor">
                        Confirmar
                    </Button>
                </el-form>
            </div>
        </div>
    </div>
    <Footer />
    <FullLoading :color="getPrimaryColorHex.five" v-show="$store.state.user.loading" />
</section>
</template>

<script>
import CnpjNameCard from '@/components/cards/CnpjNameCard'
import AlreadyRegisteredCnpjCard from '@/components/cards/AlreadyRegisteredCnpjCard'
import Footer from '@/components/navigation/footer/Footer'
import NavbarDefault from '@/components/navigation/navbar/NavbarDefault'
import FullLoading from '@/components/loading/FullLoading'
import removeMask from '@/utils/removeMask'

// import Exclamation from '@/components/icons/Exclamation'
import getPartner from '@/utils/getPartner'

import getCompanyName from '@/api/getCompanyName'
import insertCompany from '@/api/insertCompany'
import selectCompany from '@/api/selectCompany'
import getAllCnpjs from '@/api/getAllCnpjs'
import store from '@/store'

export default {
    components: {
        CnpjNameCard,
        AlreadyRegisteredCnpjCard,
        Footer,
        FullLoading,
        NavbarDefault,
        // Exclamation
    },
    data() {
        const validateCnpj = (_rule, value, message) => {
            if (this.incorretCnpj.includes(value)) message('Número de CNPJ incorreto.')
            else message()
        }
        return {
            company: {
                cnpj: '',
                name: '',
                companyType: '',
                intentUseCredit: null
            },
            rules: {
                cnpj: [{
                        required: true,
                        message: 'Por favor, insira o CNPJ da sua empresa',
                        trigger: 'change'
                    },
                    {
                        min: 18,
                        message: 'O CNPJ deve ter 14 caracteres',
                        trigger: 'change'
                    },
                    {
                        validator: validateCnpj,
                        trigger: 'change'
                    }
                ]
            },
            formValid: false,
            cnpjOk: true,
            incorretCnpj: '',
            registeredCnpj: false
        }
    },
    watch: {
        formValid(val) {
            if (val) {
                this.requestCompanyName()
            }
        },
    },
    computed: {
        userName() {
            const fullName = this.$store.state.user.infos.name
            return fullName ? fullName.split(' ')[0] : 'Undefined'
        }
    },
    methods: {
        validateForm() {
            this.$refs['company'].validate(async (valid) => {
                if (valid) {
                    this.formValid = true    
                } else {
                    this.formValid = false
                }
            });
        },
        async requestCompanyName() {
            const result = await getCompanyName(removeMask(this.company.cnpj))
            if (result.ok) {
                this.cnpjOk = true
                // this.company.name = result.payload.razao_social
                this.company.name = result.payload
            } else {
                this.incorretCnpj = this.company.cnpj
                this.validateForm()
            }
        },
        backStep() {
            if (this.$route.path.includes('signup')) return this.$router.push('/signup/password')
            return this.$router.go(-1)
        },
        async setCompany() {
            await getAllCnpjs()
            if (this.$store.state.user.companys.length > 1) {
                store.commit('user/setLoading', false)
                this.$router.push('/company/select')
            } else {
                let result = await selectCompany(removeMask(this.company.cnpj), '1')
                store.commit('user/setLoading', false)
                if (result.data.ok) {
                    window.location.href = `${this.getServiceUrls.MARKETPLACE}/home`
                }
            }
        },
        async nextStep() {
            store.commit('user/setLoading', true)
            const partner = await getPartner(this.getWhiteLabel)
            const result = await insertCompany({
                cnpj: removeMask(this.company.cnpj),
                companyType: '1',
                intentUseCredit: this.company.intentUseCredit,
                partner
            }, false)

            if (result.ok) {
                this.setCompany()                
            } else {
                store.commit('user/setLoading', false)
                if (result.data.message == 'cnpj already exists') {
                    this.cnpjOk = false
                    this.registeredCnpj = true
                } else if (result.data.message == 'there are already users linked to this cnpjcnpj already exists') {
                    this.cnpjOk = false
                    this.registeredCnpj = true
                } else {
                    this.$notify({
                        title: 'Opa! Encontramos algum erro.',
                        message: '',
                        type: 'error',
                        duration: 3000,
                        offset: 100,
                        showClose: false,
                        customClass: 'error'
                    });
                }
            }

        }
    },
    created() {
        this.$store.commit('user/setLoading', false)
    },
}
</script>

<style scoped>
.width-880 {
    max-width: 880px;
}
</style>
